import { ShapeDataFeature } from '../../zones/models/shape-data-feature';
import * as turf from '@turf/turf';
import { Utils } from '../utils';
import { DataHelper } from './data.helper';

export class ShapeHelper {
  public static createPolygonFromCircle(feature: ShapeDataFeature, zoneId: number, shapeId: number) {
    const utils: Utils = new Utils();
    if (feature.geometry.type === 'Circle') {
      const radius = utils.convertMetersToKm(feature.properties.radius);
      if (!radius) { return null; }

      const center = feature.geometry.coordinates;
      const options: any = {steps: 128};
      const circle: any = turf.circle(center, radius, options);
      feature.geometry = circle.geometry;
      feature.properties = {
        ...feature.properties,
        isCircle: true,
        center: center,
        zoneId: zoneId,
        shapeId: shapeId
      };
      if (!DataHelper.hasValue(feature.id)) {
        feature.id = utils.uuid();
      }
    } else if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon') {
      if (!feature.properties) {
        feature.properties = {};
      }
      feature.properties.zoneId = zoneId;
      feature.properties.shapeId = shapeId;
      if (!DataHelper.hasValue(feature.id)) {
        feature.id = utils.uuid();
      }
    } else {
      feature = null;
    }

    return feature
  }
}
